/**
 * Created by zjs on 2017/09/28
 */
import * as types from './mutation-types'

export default {
    /**
     * 设置页面表单中的搜索数据
     */
    setPageSearchForm ({commit}, searchForm) {
        commit(types.SET_PAGE_SEARCH_FORM, searchForm)
    },
    /**
     * 设置复制单据的详情
     */
    setCopyInfo ({commit}, info) {
        commit(types.SET_COPY_INFO, info)
    },
    /**
     * 清空复制单据
     */
    clearCopyInfo ({commit}) {
        commit(types.SET_COPY_INFO, null)
    }
} 